export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOG_OUT = "LOG_OUT";
export const LOAD_PROFILE = "LOAD_PROFILE";

export const HOME_VIDEOS_SUCCESS = "HOME_VIDEOS_SUCCESS";
export const HOME_VIDEOS_FAIL = "HOME_VIDEOS_FAIL";
export const HOME_VIDEOS_REQUEST = "HOME_VIDEOS_REQUEST";

export const SELECTED_VIDEO_REQUEST = "SELECTED_VIDEO_REQUEST"
export const SELECTED_VIDEO_SUCCESS = "SELECTED_VIDEO_SUCCESS"
export const SELECTED_VIDEO_FAILED = "SELECTED_VIDEO_FAILED"

export const CHANNEL_DETAILS_REQUEST = "CHANNEL_DETAILS_REQUEST";
export const CHANNEL_DETAILS_SUCCESS = "CHANNEL_DETAILS_SUCCESS";
export const CHANNEL_DETAILS_FAILED = "CHANNEL_DETAILS_REQUEST";

export const GET_SUBSCRIPTION_STATUS = "GET_SUBSCRIPTION_STATUS";

export const COMMENT_LIST_REQUEST = "COMMENT_LIST_REQUEST";
export const COMMENT_LIST_SUCCESS= "COMMENT_LIST_SUCCESS";
export const COMMENT_LIST_FAILED = "COMMENT_LIST_FAILED";

export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_FAILED = "CREATE_COMMENT_FAILED";

export const RELATED_VIDEO_REQUEST = "RELATED_VIDEO_REQUEST";
export const RELATED_VIDEO_SUCCESS = "RELATED_VIDEO_SUCCESS";
export const RELATED_VIDEO_FAILED = "RELATED_VIDEO_FAILED";


export const SEARCH_VIDEO_REQUEST = "SEARCH_VIDEO_REQUEST";
export const SEARCH_VIDEO_SUCCESS = "SEARCH_VIDEO_SUCCESS";
export const SEARCH_VIDEO_FAILED = "SEARCH_VIDEO_FAILED";